import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export default async function postExistingHfrToClinic({
  clinicId,
  hfrId,
  doctorId,
}: {
  clinicId: string;
  hfrId: string;
  doctorId: string;
}): Promise<AxonGenericApiResponse<undefined>> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({
      clinic_id: clinicId,
      hfr_id: hfrId,
    });

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hfr/link?doctor_oid=${doctorId}`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
